// extracted by mini-css-extract-plugin
export var aboveInput = "_fk-0";
export var actionButton = "_fk-5";
export var actionButtonContainer = "_fk-1";
export var actionIcon = "_fk-6";
export var aiInfoContainer = "_fk-2";
export var attachmentWrapper = "_fk-7";
export var bold = "_fk-3";
export var checkIcon = "_fk-8";
export var clickingRecipientBar = "_fk-11";
export var commentThreadSwitch = "_fk-a";
export var draftImage = "_fk-b";
export var draftImageContainer = "_fk-c";
export var draftImages = "_fk-e";
export var editButton = "_fk-g";
export var editor = "_fk-f";
export var editorContainer = "_fk-y";
export var editorErrorTooltipWrapper = "_fk-9";
export var headerDivider = "_fk-h";
export var icon = "_fk-i";
export var info = "_fk-j";
export var internal = "_fk-n";
export var internalDivider = "_fk-k";
export var internalMessage = "_fk-l";
export var messageInputCard = "_fk-m";
export var messageInputForm = "_fk-o";
export var messageInputFormInternal = "_fk-p";
export var options = "_fk-q";
export var publicMessageCustomer = "_fk-s";
export var publicMessageMerchant = "_fk-r";
export var removeImageButton = "_fk-d";
export var replyButtons = "_fk-t";
export var showSignatureButton = "_fk-u";
export var spinner = "_fk-v";
export var verticalButtonDivider = "_fk-4";
export var visibilitySelector = "_fk-w";
export var warning = "_fk-x";
export var wrappingText = "_fk-z";
export var writingInternalNoteTopBorder = "_fk-10";